Funtion Number AutoComplete





<p-autoComplete [ngModel]="selectedFunctionNumbers" (ngModelChange)="onModelChange($event)" [suggestions]="functionNumbers" (completeMethod)="search($event)" multiple="true" field="number">
  <ng-template let-functionNumber pTemplate="item">
    <div class="country-item">
      <!--<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" [class]="'flag flag-' + country" />-->
      <!--<mat-icon class="mat-icon-widget-type-button flag">speed</mat-icon>-->
      <img src="{{baseHref}}Library/GetUserAvatar?libraryId={{functionNumber.avatarImageId ?? -1}}" class="flag" style="border-radius: 10px;" />
      
      <div>{{functionNumber.number}}</div>
    </div>
  </ng-template>
</p-autoComplete>
